module.exports = __webpack_public_path__ + "static/img/logo.bfb76750.png";